module.exports = __webpack_public_path__ + "img/icon-map-merah.de5598ce.png";